import { Component } from '@angular/core';
import {PosIntegrationService} from '../../../../services/pos-integration.service';
import {HelpersService} from '../../../../services/helpers.service';
import moment from 'moment';

@Component({
  selector: 'app-pos-sync-status',
  templateUrl: './pos-sync-status.component.html',
  styleUrls: ['./pos-sync-status.component.scss']
})
export class PosSyncStatusComponent {

  public loadingData : boolean = false;
  public syncStatus : any = {};
  public countryData : any = {};
  public stopLoop : boolean = false;
  public syncStarted : boolean = false;
  public customerSyncData : any = {};
  public fetchingCustomer : boolean = false;

  constructor(
    private helpersService: HelpersService,
    private posIntegrationService: PosIntegrationService
  ) {}

  ngOnInit(): void {    
    this.countryData = this.helpersService.getCountryData();
    console.log(this.countryData)
    this.loadingData = true;
    this.getSyncStatus();    
  }

  ngOnDestroy(): void {
    this.stopLoop = true;
  }

  getSyncStatus(){    
    this.posIntegrationService.getPartnerPOSSyncStatus(this.helpersService.getPartnerId()).subscribe((syncStatus)=>{
      this.syncStatus = syncStatus;
      console.log(this.syncStatus)
      this.loadingData = false;
      if(this.syncStatus && this.syncStatus.CustomerCount > 50000){
        this.customerSyncData = {
          uniqueRecords : this.syncStatus.CustomerCount,
          syncedToday : this.syncStatus.CustomersUpdatedToday
        }
      }else{
        this.getCustomerSyncStatus();
      }
    });
  }

  
  getCustomerSyncStatus() {
    this.fetchingCustomer = true;
    this.posIntegrationService
      .getPartnerCustomerSyncStatusStream(this.helpersService.getPartnerId())
      .subscribe({
        next: (chunk) => {
          this.customerSyncData = JSON.parse(chunk);
          console.log(this.customerSyncData)
        },
        error: (err) => {
          this.fetchingCustomer = false;
        },
        complete: () => {
          this.fetchingCustomer = false;
        },
      });
  }

  getLocalDate(date : Date){
    return moment.utc(date).toDate();
  }
  
  getLocalDateFormat(date : Date){
    return moment.utc(date).format(this.countryData.MomentDateFormat);
  }

  syncProducts(){
    this.syncStarted = true;
    this.syncStatus.POSSyncBusy = true;
    this.posIntegrationService.startPOSSync(this.helpersService.getPartnerId()).subscribe((status)=>{
      this.getSyncStatus();
      this.syncStarted = false;
    });
  }

  syncCustomers(){
    this.syncStarted = true;
    this.syncStatus.POSSyncBusy = true;
    this.posIntegrationService.startIncrementalPOSClientSync(this.helpersService.getPartnerId()).subscribe((status)=>{
      this.getSyncStatus();
      this.syncStarted = false;
    });
  }

  isProductSyncBusy(){
    return (this.syncStatus.PartnerSyncProgress && this.syncStatus.PartnerSyncProgress.ID && this.syncStatus.PartnerSyncProgress.IsProductSyncBusy ? true : (!this.syncStatus.PartnerSyncProgress || !this.syncStatus.PartnerSyncProgress.ID) && this.syncStatus.POSSyncBusy ? true : false) || this.syncStarted;
  }

}
